<div class="admin-children" [class]="{ active: isActive }">
  <p class="display-text" [class]="{ active: isActive }" [routerLink]="link">
    {{ displayText() }}
  </p>
  @if (isActive) {
    <ion-icon alt="done" class="check" src="assets/sidebar-icons/done.svg" />
  }
</div>
